export default __webpack_public_path__ + "static/media/Search_Icon.80fca255.svg";